<template>
  <div class="content">
    <div class="content-class">
      <p class="content-title">投诉信息</p>
      <div class="neir-class">
        <div class="nrxq-class">
          <div>
            <span class="zb-class">投诉单号</span>
            <span class="yb-class">{{complaintInformation.complaintId}}</span>
          </div>
          <div class="dzb-class">
            <span class="zb-class">投诉金额</span>
            <span class="yb-class">{{complaintInformation.amount}}</span>
          </div>
        </div>
        <div class="nrxq-class">
          <div>
            <span class="zb-class">投诉时间</span>
            <span class="yb-class">{{complaintInformation.complaintTime}}</span>
          </div>
          <div>
            <span class="zb-class">问题类型</span>
            <span class="yb-class">{{complaintInformation.problemDescription}}</span>
          </div>
        </div>
        <div class="nrxq-class">
          <div>
            <span class="zb-class">ICCID</span>
            <span class="yb-class">{{complaintInformation.iccid}}</span>
          </div>
          <div>
            <span class="zb-class">联系方式</span>
            <span class="yb-class">{{complaintInformation.phone}}</span>
          </div>
        </div>
        <div class="nrxq-class">
          <div>
            <span class="zb-class">投诉次数</span>
            <span class="yb-class">{{complaintInformation.userComplaintTimes}}</span>
          </div>
          <div>
            <span class="zb-class">投诉单状态</span>
            <span class="yb-class">{{complaintInformation.complaintState}}</span>
          </div>
        </div>
        <div class="nrxq-class">
          <div>
            <span class="zb-class">被投诉商户名称</span>
            <span class="yb-class">{{complaintInformation.appName}}</span>
          </div>
          <div>
            <span class="zb-class"> 支付订单号</span>
            <span class="yb-class">{{complaintInformation.orderNum}}</span>
          </div>
        </div>
        <div class="nrxq-class">
          <div>
            <span class="zb-class">外部订单号</span>
            <span class="yb-class">{{complaintInformation.transactionId}}</span>
          </div>
        </div>
      </div>
      <p class="content-title">投诉进展</p>
      <div class="progress-class">
        <el-steps :active="complaintInformation.complaintStep" finish-status="success" align-center>
          <el-step title="用户发起投诉"></el-step>
          <el-step title="待处理"></el-step>
          <el-step title="处理中"></el-step>
          <el-step title="已处理完成"></el-step>
        </el-steps>
      </div>
      <p class="content-title">
        <span>协商历史</span>
      </p>
      <div style="margin-top: 30px;padding-bottom: 30px;">
        <el-table :data="tableData" border>
          <el-table-column prop="operateTime" label="时间" align="center" width="300px"></el-table-column>
          <el-table-column prop="operator" label="角色" align="center" width="300px"></el-table-column>
          <el-table-column prop="answerName" label="操作人" align="center" width="300px"></el-table-column>
          <el-table-column prop="operateDetails" label="内容" align="center"></el-table-column>
        </el-table>
      </div>
      <el-form :model="from" ref="from" :rules="ruleValidate">
        <el-form-item label="反馈类目"  prop="feedbackCode" :label-width="LabelWidth" v-if="complaintInformation.type=='2'">
          <el-select v-model="from.feedbackCode" placeholder="请选择反馈类目" v-if="complaintInformation.channel=='1'">
            <el-option label="使用体验保障金退款" value="00"></el-option>
            <el-option label="通过其他方式退款" value="02"></el-option>
            <el-option label="已发货" value="03"></el-option>
            <el-option label="其他" value="04"></el-option>
            <el-option label="已完成售后服务" value="05"></el-option>
            <el-option label="非我方责任范围" value="06"></el-option>
          </el-select>
          <el-select v-model="from.feedbackCode" placeholder="请选择反馈类目" v-if="complaintInformation.channel=='2'">
            <el-option label="已联系到用户，协商一致，无异议" value="CONSENSUS_WITH_CLIENT"></el-option>
            <el-option label="其他" value="ORTHER"></el-option>
            <el-option label="不涉及退款，已针对投诉内容进行整改" value="RECTIFICATION_NO_REFUND"></el-option>
            <el-option label="已退款，用户无异议" value="REFUND"></el-option>
            <el-option label="已提交证明材料" value="SUBMIT_PROOF_NOT_CONTACTED"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回复内容：" prop="message" :label-width="LabelWidth">
          <el-input type="textarea" :rows="6" v-model="from.message" style="width: 45%;" placeholder="请输入回复内容" @input="descInput" maxlength="200"></el-input>
          <span style="position: relative;top: 6px;left: -55px;">{{txtVal}}/200</span>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="saveDialog('from')" style="margin: 0 0 50px 95px;">提交</el-button>
    </div>
  </div>
</template>
<script>
import { complainDetail } from "@/api/api.js"; //微信投诉详情
import { complainConsultList } from "@/api/api.js"; //微信投诉协商历史
import { complainAnswerComplaint } from "@/api/api.js"; //微信投诉消息回复
export default {
  data() {
    return{
      tableData:[],
      dialogVisible:false,
      from:{},
      LabelWidth: "100px",
      ruleValidate:{
        message: [
          { required: true, message: "请输入回复内容", trigger: "blur" },
          { min: 10,max: 200,message: "请输入10至200字的内容",trigger: "blur" },
        ],
        feedbackCode: [
          { required: true, message: "请选择反馈类目", trigger: "blur" }
        ],
      },
      txtVal:0,
      complaintInformation:{}
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        complaintId:this.$route.params && this.$route.params.complaintId
      };
      complainDetail(params).then(res=>{
        if (res.data.code == 200) {
          this.complaintInformation = res.data.data;
          this.complaintInformation.complaintStep = + this.complaintInformation.complaintStep;
          if(this.complaintInformation.complaintState == "2"){
            this.complaintInformation.complaintState = "待处理";
          }else if(this.complaintInformation.complaintState == "3"){
            this.complaintInformation.complaintState = "处理中";
          }else{
            this.complaintInformation.complaintState = "已完成";
          }
        }
      });
      complainConsultList(params).then(res=>{
        this.tableData = res.data.data;
      })
    },
    // 消息回复提交
    saveDialog(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            complaintId:this.complaintInformation.complaintId,
            msg:this.from.message,
            feedbackCode:this.from.feedbackCode
          }
          complainAnswerComplaint(params).then(res=>{
            if (res.data.code == 200) {
              this.$message.success("回复成功");
              this.initData()
              this.from.message  = '';
            }
          })
        }
      })
    },
    // 监听输入内容的长度
    descInput(){
      this.txtVal = this.from.message.length;
    },
  },
  mounted() {
    this.initData()
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">
.content-class{
  .content-title{
    border-left: 3px solid #00c250;
    font-size: 18px;
    padding-left: 10px;
    font-weight: 600;
    line-height: 16px;
    display: inline-block;
    margin-top: 20px;
  }
  .neir-class{
    margin-top: 20px;
    .nrxq-class{
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      height: 50px;
      line-height: 50px;
      div{
        width: 50%;
        margin-left: 30px;
        font-size: 16px;
        .zb-class{
          color: #999;
          display: inline-block;
          width: 128px;
          text-align: left;
        }
        .yb-class{
          font-weight: 540;
          color: #333;
          vertical-align: baseline;
        }
      }
    }
  }
  .progress-class{
    width: 70%;
    margin-top: 20px;
    margin-left:30px;
  }
}
/deep/ .el-textarea__inner{
  resize:none;
}
</style>


